import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// Components
import SVG from 'components/widgets/icons/svg';
import TicketLink from 'components/models/ticket/ticket-link';


export default function AddToTicketOption({ triageItem }) {
  const ticketed = !_.isEmpty(triageItem.ticket);
  const onClick = ticketed ? _.noop : () => triageItem.setOpen('addToTicket');
  const classes = classNames('triage-option-header', { 'triage-action-complete': ticketed });

  return (
    <div className="triage-option-ticket">
      <div onClick={onClick} className={classes}>
        <SVG src="svg/ticket.svg" className="ticket triage-option-icon" />
        { _.isEmpty(triageItem.ticket) ?
          <span>Ticket</span> :
          <span>Ticket: <TicketLink ticket={triageItem.ticket} /></span>
        }
      </div>
    </div>
  );
}

AddToTicketOption.propTypes = {
  triageItem: PropTypes.object.isRequired
};



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/add-to-ticket.js